import { useContext } from 'react';
import UserContext from '../UserContext';
import { Login_CONCTRACT } from '../config';
import Web3 from "web3";

//This script handles the login contract on MultiVAC

export const useLogLogin = () => {

    const { userInfo, updateUser, web3 } = useContext(UserContext);

    const abi = [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "internalType": "uint256",
                    "name": "timestamp",
                    "type": "uint256"
                }
            ],
            "name": "Login",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "login",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ];

    const logLogin = async (wallet_address) => {
        if (!web3 || !wallet_address) {
            console.log("Web3 is not initialized or no account is connected.");
            return false;  // Indicate failure
        }

        const contract = new web3.eth.Contract(abi, Login_CONCTRACT);

        try {
            const gasPrice = await web3.eth.getGasPrice();
            const transactionResponse = await contract.methods.login().send({
                from: wallet_address,
                gasPrice: gasPrice
            });

            console.log('Transaction Successful:', transactionResponse.transactionHash);
            if (updateUser) {
                updateUser({ lastLogin: new Date().toISOString() });
            }
            return transactionResponse.transactionHash;  
        } catch (error) {
            console.error('Login logging failed:', error);
            return false;  // Indicate failure
        }
    };

    return logLogin;
};
